export default "__VITE_ASSET__f98d351d__"